import React from 'react';
import { CollapsiblePanel, PanelBody, EditPanelRow, EditPanelCell } from '../../../components/elements';
import { DraggableContainer } from '../../../components/react-smooth-dnd/DraggableContainer';
import { DraggableItem } from '../../../components/react-smooth-dnd/DraggableItem';
import { AssetDropzone } from '../../../components/Surveys/Common/AssetDropzone';
import { AssetTemplate } from '../../../components/Surveys/Common/AssetTemplate';
import { assetToAssetType } from '../../../components/validatingElements';

export function SurveyEditPhotosPanel(props: {
    unitName: string;
    surveyId: string;
    objectId: string;
    photos: any[] | undefined;
    onPhotosChanged: (photos: any[]) => void;
}) {
    return (
        <CollapsiblePanel heading={{ dark: true, text: `${props.unitName} foto's`, initialIsClosed: false }}>
            <PanelBody isForm={true}>
                <EditPanelRow>
                    <EditPanelCell rowCount={12}>
                        <div className="row section pt10 mh10 ph20 ">
                            <AssetDropzone
                                acceptedFiles={'.png,.jpg,.jpeg'}
                                onComplete={(file) => {
                                    if (file.status === 'success') {
                                        props.onPhotosChanged([
                                            ...(props.photos ?? []),
                                            {
                                                // eslint-disable-next-line react-hooks/rules-of-hooks
                                                assetId: file.s3Id,
                                                filename: file.name,
                                                mimeType: file.type,
                                            },
                                        ]);
                                    }
                                }}
                                objectId={props.objectId}
                                surveyId={props.surveyId}
                                autoProcessQueue={true}
                            />
                        </div>
                    </EditPanelCell>
                    <EditPanelCell rowCount={12}>
                        {!props.photos || props.photos.length === 0 ? null : (
                            <div className="section row pt10 pr20 pl20 bg-light dark">
                                <DraggableContainer orientation="horizontal" dragHandleSelector=".column-drag-handle">
                                    {props.photos &&
                                        props.photos.map(
                                            (
                                                asset: { assetId: string; id?: string; description: string; type: string; filename?: string },
                                                i: number,
                                            ) => (
                                                <DraggableItem key={asset.assetId} className="col-sm-6 col-md-3">
                                                    <AssetTemplate
                                                        id={asset.assetId ?? asset.id}
                                                        order={i}
                                                        objectId={props.objectId}
                                                        surveyId={props.surveyId}
                                                        type={assetToAssetType(asset)}
                                                        onAssetsChanged={async () => {
                                                            // noop
                                                        }}
                                                        onAssetRemoved={() => {
                                                            props.onPhotosChanged(
                                                                props.photos?.filter((b: { assetId: string }) => b.assetId !== asset.assetId) ?? [],
                                                            );
                                                        }}
                                                        canRemove
                                                        onAssetTextChange={(t) => {
                                                            props.photos![i]!.description = t;
                                                            props.onPhotosChanged([...(props.photos ?? [])]);
                                                        }}
                                                        description={asset.description}
                                                    />
                                                </DraggableItem>
                                            ),
                                        )}
                                </DraggableContainer>
                            </div>
                        )}
                    </EditPanelCell>
                </EditPanelRow>
            </PanelBody>
        </CollapsiblePanel>
    );
}
